<div class="typical-error__item tile o-flex o-flex--justify-space-between u-margin-5" *ngFor="let item of typicalErrorList">
  <div class="o-flex o-flex--column o-flex--justify-center line-height-24">
    <div>
      <span class="u-font-size-17 u-font-weight-400 text-color">{{item.name}}</span>
    </div>
    <div>
      <span class="u-font-size-14 u-font-weight-400 disabled-text">± {{item.value}} {{item.unit}}</span>
    </div>
  </div>
  <div class="o-flex o-flex--justify-center o-flex--align-items-center">
    <mat-icon class="typical-error--dimension" *ngIf="item.color === TYPICAL_ERROR_ENUM.GREEN" svgIcon="success-smile"></mat-icon>
    <mat-icon class="typical-error--dimension" *ngIf="item.color === TYPICAL_ERROR_ENUM.YELLOW" svgIcon="warning-smile"></mat-icon>
    <mat-icon class="typical-error--dimension" *ngIf="item.color === TYPICAL_ERROR_ENUM.RED" svgIcon="error-smile"></mat-icon>
  </div>
</div>
